import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import LandsDt from '@/services/dataTransferModules/landsDt'

import { haveCommonElements } from '@/helpers/arrayHelper'

const landsDt = new LandsDt()

export default function useLands() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fullLands,
		getEntities: getFullLands,

		basedEntities: baseLands,
		getBasedEntities: _getBaseLands,

		extendedEntities: extendLands,
		getExtendedEntities: getExtendLands,

		entity: land,
		getEntity: getLand,

		entityPreview: landPreview,
		getEntityPreview: getLandPreview,

		entityPopup: landPopup,
		getEntityPopup: getLandPopup,

		createEntity: createLand,
		patchEntity: patchLand,
		updateEntity: putLand,
		deleteEntity: deleteLand,
	} = useBlProviders(landsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error loading land plots'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Error loading land plot'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error when creating a land plot'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error when editing a land plot'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Error when deleting a land plot'),
	})

	const hashedBaseLands = ref({})

	const getFilteredLands = (lands, filter = {}) => {
		if (Object.keys(filter).length >= 1) {
			return lands.filter((land) => {
				const conditions = []
				if (Object.prototype.hasOwnProperty.call(filter, 'fields_ids')) {
					if (Array.isArray(filter['fields_ids'])) {
						conditions.push(haveCommonElements(land.linked_fields_ids ?? [], filter['fields_ids']))
					} else if (typeof filter['fields_ids'] === 'number') {
						conditions.push((land.linked_fields_ids ?? []).includes(filter['fields_ids']))
					}
				}
				return conditions.every((el) => (el))
			})
		}
		return lands
	}

	/**
	 * getBasedEntities отдаёт с бэка полный "based"-список без фильтрации. Фильтрация по
	 * fields_ids и обогащение __ao_cadastral_number__ выполняются на клиенте, как в старой
	 * версии; hashedBaseLands строится из уже отфильтрованного и обогащённого списка.
	 */
	const getBaseLands = (payload) => {
		return _getBaseLands().then((res) => {
			const enriched = getFilteredLands(res, payload).map((land) => ({
				...land,
				__ao_cadastral_number__: land.cadastral_number || $t('Without cadastral number'),
			}))

			baseLands.value = enriched
			hashedBaseLands.value = enriched.reduce((acc, land) => {
				acc[land.id] = land
				return acc
			}, {})

			return res
		})
	}

	return {
		flags,
		fullLands,
		baseLands,
		hashedBaseLands,
		extendLands,
		land,
		landPreview,
		landPopup,

		getFullLands,
		getBaseLands,
		getExtendLands,
		getLand,
		getLandPreview,
		getLandPopup,
		createLand,
		putLand,
		patchLand,
		deleteLand,
	}
}
